import React from 'react';
import './Breadcrumb.scss';
import { Link } from 'react-router-dom';
import { t, translate } from 'react-switch-lang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-unresolved
import { faChevronRight } from '@awesome.me/kit-299dd46f46/icons/classic/solid';
import { makeLowerAndOnlyLetter } from '../../helperFunctions/LinkGenerator';
import { brandTitleGet } from '../../configurations/Brands';
import ReplaceTextWithElement from '../../helperFunctions/ReplaceTextWithElement';

function BreadcrumbItem({
  brand,
  lang,
  type,
  id,
  title,
  active = true,
}) {
  let paths = '';
  [brand, lang, type, id, title].find((path, i) => {
    if (!path) return true;
    paths += i !== 4 ? `/${path}` : `-${makeLowerAndOnlyLetter(path)}`;
    return false;
  });

  return (
    <>
      {type && (
        <FontAwesomeIcon className="chevron-style" icon={faChevronRight} size="2x" aria-label={t('IconDescription_Breadcrumb_Chevron')} />
      )}
      <li>
        {active ? (
          <Link
            className="hyperlink breadcrumb-link"
            to={paths}
          >
            <ReplaceTextWithElement
              text={title}
              replaceWith={<i>Interac</i>}
              replaceKey="Interac"
            />
          </Link>
        ) : (
          <span className="breadcrumb-link">
            <ReplaceTextWithElement
              text={title}
              replaceWith={<i>Interac</i>}
              replaceKey="Interac"
            />
          </span>
        )}
      </li>
    </>
  );
}

function Breadcrumb({
  categoryID,
  categoryName,
  sectionID,
  sectionName,
  lang,
  lastActive,
  articleStatus,
}) {
  if (articleStatus === 'H') return null;

  const urlPath = window.location.pathname;
  const brand = urlPath.match(/\/([^/]*)/)[1];
  const propsList = [];

  propsList.push({
    title: brandTitleGet(brand, lang),
  });
  if (categoryID) {
    propsList.push({
      type: 'categories',
      id: categoryID,
      title: categoryName,
    });
  }
  if (sectionID) {
    propsList.push({
      type: 'sections',
      id: sectionID,
      title: sectionName,
    });
  }
  if (!lastActive) propsList[propsList.length - 1].active = false;

  return (
    <div className="custom-breadcrumb">
      <nav
        aria-label={t('LinkDescription_Breadcrumb')}
        id="breadcrumbs"
        role="navigation"
      >
        <div className="breadcrumb-text">
          <ol>
            {propsList.map((props) => (
              <BreadcrumbItem
                brand={brand}
                lang={lang}
                {...props}
                key={props.type ?? 'brand'}
              />
            ))}
          </ol>
        </div>
      </nav>
    </div>
  );
}

export default translate(Breadcrumb);
